import React, { useEffect, useRef, useState } from 'react'
import { Link, useLoaderData } from 'react-router-dom'
import AxiosInstance from 'src/components/Axios'
import { useNavigate } from 'react-router-dom'
import { CForm, CFormLabel, CFormInput, CButton, CCol, CImage, CInputGroup, CRow, CCardHeader, CFormTextarea } from '@coreui/react'
import AsyncSelect from 'react-select/async'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import MyToastify from 'src/components/myComponents/MyToactify'
// import css from './WorkersForm.module.scss'
import CIcon from '@coreui/icons-react'
import { cilTrash } from '@coreui/icons'
import { confirmAlert } from 'react-confirm-alert'
import 'react-confirm-alert/src/react-confirm-alert.css'
import { MdOutlineAddAPhoto } from 'react-icons/md'
import { BsFillPersonFill } from 'react-icons/bs'
import MyDirective from './MyDirective'
import dayjs from 'dayjs';
import ButtonsBlock from 'src/components/jobs/jobsUpdate/ButtonsBlock'

const urlApi = '/subpoenas'
// const urlApi_2 = '/subpoena'
// const urlRouter = '/workers'
// const urlRouterUpdate = '/workers/update'
// const urlMedia = '/media_objects'

// токен
const tokenStr = localStorage.getItem('user')
const header = { headers: { Authorization: `Bearer ${tokenStr}`, accept: 'application/json' } }
const role = localStorage.getItem('user_role')
// id користувача
const userData = JSON.parse(localStorage.getItem('user_data'))
// console.log('userData',userData);

export async function LoaderDirectivesUpdate({ params }) {
   const id = params.pid

   if (Object.keys(params).length !== 0) {
      try {
         const response1 = await AxiosInstance.get(`${urlApi}/${id}`
            // , header
         )

         return {
            data: response1.data
            // , data2: response2.data 
         }
      } catch (error) {
         console.error('Помилка під час виконання запитів', error)
         return null
      }
   }

   return null
}

export default function MyDirectivesForm() {
   const navigate = useNavigate()
   // дані для оновлення перші

   const { data } = useLoaderData() || {}
   // console.log('data', data)
   // console.log('дані контрагента', data2)


   // const [selectedOption, setSelectedOption] = useState(
   //    data2 && data2.length > 0 ? { label: data2[0].account.name, id: data2[0].account.id } : null,
   // )
   // Заблокувати можливу зміну, оскільки дані вже вневені в 1С
   const [isDisabledAll, setIsDisabledAll] = useState(false);

   // Блокувати можливу зміну даних, якщо data.status === "checked"
   const [isDisabledChange, setIsDisabledChange] = useState(false)
   // Чи відправити документи на перевірку Адміну
   const [isSendForInspection, setIsSendForInspection] = useState(false)
   const [isDisabledSend, setIsDisabledSend] = useState(false)

   //статус припису
   const [synkStatus, setSynkStatus] = useState(data?.synkStatus ? data.synkStatus : '')
   const [dataState, setDataState] = useState(data)


   // Для видалення старого фото після завантаження нового
   const [inputValue, setInputValue] = useState('')

   // стан для перевірки чи заповнені поля imageAfter і dateAfter в subpoena_items
   const [AllRequiredFieldsAreFilledIn, setAllRequiredFieldsAreFilledIn] = useState(false)

   useEffect(() => {
      if (data) {
         setDataState(data)
      }
   }, [data])

   useEffect(() => {
      // console.log('dataState', dataState)
   }, [dataState])


   const parseDateString = (dateString) => {
      const date = new Date(dateString)
      const day = date.getDate().toString().padStart(2, '0')
      const month = (date.getMonth() + 1).toString().padStart(2, '0')
      const year = date.getFullYear().toString()

      return { day, month, year }
   }


   //    const [series, number] = seriesString.split(' ')
   //    return { series, number }
   // }

   // useEffect(() => {
   //    if (data?.seriaPasport) {
   //       const parsedSeries = parseSeriesString(data.seriaPasport)
   //       setCombinedSeries(parsedSeries)
   //    }
   // }, [])

   // Викликає popup з власного компонента

   // поточна дата
   const currentDate = new Date()


   const loadOptions = async (inputValue) => {
      if (role === 'ROLE_ADMIN') {
         // return await AxiosInstance.get(`/accounts?user.id=${userData.id}`, header).then((response) => {

         // return await AxiosInstance.get(`/accounts`, header).then((response) => {
         // пошук за введеними даними в полі введення
         return await AxiosInstance.get(`/accounts?name=${inputValue}`, header).then((response) => {
            // console.log('response.data', response.data);

            return response.data.map((result) => ({
               label: result.name,
               value: result.id,
            }))
         })
      } else {
         //якщо я зареєстрований але не адмін
         if (userData.id) {
            return await AxiosInstance.get(`/accounts?user.id=${userData.id}`, header).then(
               (response) => {
                  // console.log(123131231231, response.data);

                  return response.data.map((result) => ({
                     label: result.name,
                     value: result.id,
                  }))
               },
            )
         }
      }
   }

   function allRequiredFieldsAreFilledIn() {

      if (dataState.subpoenaItems.some(item => !item.dateAfter || !item.imageAfter)) {
         setAllRequiredFieldsAreFilledIn(false)
         // return false
      } else {
         setAllRequiredFieldsAreFilledIn(true)
         // return true
      }

   }

   // Чи відправлено на перевірку
   useEffect(() => {
      allRequiredFieldsAreFilledIn()
   }, [dataState]);

   // function changeStatusForSendToVerify() {
   //    const data_response = { synkStatus: 'send_to_verify' }
   //    AxiosInstance.patch(
   //       `${urlApi}/${dataState.id}`,
   //       data_response,
   //       header,
   //    ).then(
   //       (response) => {
   //          console.log(response)
   //          setDataState(response.data)
   //          setSynkStatus(response.data.synkStatus)
   //       }
   //    )
   // }


   // function changeStatusToVerified() {
   //    const data_response = { synkStatus: 'verified' }
   //    AxiosInstance.patch(
   //       `${urlApi}/${dataState.id}`,
   //       data_response,
   //       header,
   //    ).then(
   //       (response) => {
   //          console.log(response)
   //          setDataState(response.data)
   //          setSynkStatus(response.data.synkStatus)
   //       }
   //    )
   // }

   //функція з алертом,для умовної перевірки

   // async function verified() {
   //    try {
   //       await confirmAlert({
   //          title: 'Ви впевнені що хочите підтвердити цей пункт ?',
   //          message: 'Are you sure to do this.',
   //          buttons: [
   //             {
   //                label: 'Так',
   //                onClick: async () => changeStatusToVerified()
   //             },
   //             {
   //                label: 'Ні',
   //                onClick: () => {
   //                   return
   //                },
   //             },
   //          ],
   //       })
   //    } catch (error) {
   //       console.error('Помилка видалення:', error)
   //    }
   // }




   // function changeStatusToNew() {
   //    const data_response = { synkStatus: 'new' }
   //    AxiosInstance.patch(
   //       // `${urlApi}/${data.id}`,
   //       `${urlApi}/${dataState.id}`,
   //       data_response,
   //       header,
   //    ).then(
   //       (response) => {
   //          console.log(response)
   //          setDataState(response.data)
   //          setSynkStatus(response.data.synkStatus)
   //       }
   //    )
   // }

   //функція з алертом,для умовного повернення партнеру

   // async function changeToNew() {
   //    try {
   //       await confirmAlert({
   //          title: 'Ви впевнені що хочите повернути на доопрацювання ?',
   //          message: 'Are you sure to do this.',
   //          buttons: [
   //             {
   //                label: 'Так',
   //                onClick: async () => changeStatusToNew()
   //             },
   //             {
   //                label: 'Ні',
   //                onClick: () => {
   //                   return
   //                },
   //             },
   //          ],
   //       })
   //    } catch (error) {
   //       console.error('Помилка видалення:', error)
   //    }
   // }

   useEffect(() => {
      if (data) {
         setDataState(data)
      }
   }, [data])

   return (
      <div className='d-flex justify-content-center'>
         <CForm
            className="mb-3 ">

            {/* Відображати тільки для Адміна -блок підтвердження*/}
            {/* {
               (role === "ROLE_ADMIN") &&
               <div className="d-flex align-items-center">
                  {
                     (dataState?.synkStatus === "send_to_verify") &&
                     <CButton
                        className="ms-3"
                        onClick={verified}
                        color="success"

                     >
                        Підтвердити
                     </CButton>
                  }



                  {
                     (dataState?.synkStatus === "send_to_verify") &&
                     <>
                        <CButton
                           className="ms-3"
                           onClick={changeToNew}
                           color="danger"

                        >
                           Повернути
                        </CButton>
                     </>
                  }

                  {
                     (dataState?.synkStatus === "verified") &&
                     <>
                        <CButton
                           className="ms-3"
                           color="primary"
                        >
                           Перевірено
                        </CButton>
                     </>
                  }

                  {
                     (dataState?.synkStatus === "synced") &&
                     <>
                        <CButton
                           className="ms-3"
                           color="btn-warning"

                        >
                           Внесено в 1c

                        </CButton>
                     </>
                  }

               </div>
            } */}

            <div style={{
               maxWidth: '500px',
               //  marginRight: '100px',
               marginLeft: 'auto',
               marginRight: "auto"
            }}>
               <CRow className='mb-3 text-center'>
                  <>
                     <h4>Дані припису</h4>
                     {/* <small></small> */}
                  </>
               </CRow>
               <CRow className="d-flex ">
                  <CCol className="mb-6">
                     <CFormLabel htmlFor="exampleFormControlInput1">Підрозділ</CFormLabel>
                     <CFormInput
                        type="text"
                        id="exampleFormControlInput1"
                        disabled={true}
                        value={dataState.factory.name || ''}
                        autoComplete="off"
                        required
                     />
                  </CCol>
                  <CCol className="mb-6">
                     <CFormLabel htmlFor="exampleFormControlInput2">Контрагент</CFormLabel>
                     <CFormInput
                        type="text"
                        id="exampleFormControlInput1"
                        disabled={true}
                        value={dataState.account.name || ''}
                        autoComplete="off"
                        required
                     />
                  </CCol>


               </CRow>
               <CRow>

                  <CCol className="mb-6">
                     <CFormLabel htmlFor="exampleFormControlInput3">Дата створення</CFormLabel>
                     <CFormInput
                        type="text"
                        id="exampleFormControlTextarea1"
                        disabled={true}
                        value={dayjs(dataState.date).local().format('DD.MM.YYYY HH:mm') || ''}
                        autoComplete="off"
                        required
                     />
                  </CCol>

                  <CCol className="mb-6">
                     <CFormLabel htmlFor="exampleFormControlInput4">Код</CFormLabel>
                     <CFormInput
                        type="text"
                        id="exampleFormControlInput1"
                        disabled={true}
                        value={dataState.code || ''}
                        autoComplete="off"
                        required
                     />
                  </CCol>


               </CRow>
               <CRow>
                  <CCol className="mb-6">
                     <CFormLabel htmlFor="exampleFormControlInput5">Ким створено</CFormLabel>
                     <CFormInput
                        type="text"
                        id="exampleFormControlInput1"
                        disabled={true}
                        value={dataState.created || ''}
                        autoComplete="off"
                        required
                     />
                  </CCol>
               </CRow>
               <CRow>
                  <CCol className="mb-6">
                     <CFormLabel htmlFor="exampleFormControlInput6">Опис</CFormLabel>
                     <CFormTextarea
                        type="text"
                        id="exampleFormControlInput1"
                        disabled={true}
                        value={dataState.description || ''}
                        autoComplete="off"
                        required
                     />
                  </CCol>
               </CRow>
            </div>


            {dataState.subpoenaItems.map(item => {
               return <MyDirective
                  role={role}
                  header={header}
                  key={item.id}
                  dataItem={item}
                  subpoenaId={data.id}
                  setDataState={setDataState}
                  dataState={dataState}
               />
            }
            )
            }


            {/* isDisabledAll={true} - Заблокувати можливу зміну */}
            {
               !isDisabledAll &&
               <>
                  <hr />

                  {/* Блок кнопок */}
                  {/* <ButtonsBlock
                     dataState={dataState} role={role}
                     isDisabledChange={isDisabledChange} isSendForInspection={isSendForInspection}
                     isDisabledSend={isDisabledSend}
                     changeStatus={changeStatus}
                     addComentar={addComentar}
                     comentar={comentar}
                     setOpenWarningForEngineer={setOpenWarningForEngineer}
                     setOpenWarningForMainEngineerOp={setOpenWarningForMainEngineerOp}
                     isMainEngineerOp={props.isMainEngineerOp}
                  /> */}


                  {/* 
                  {(role === 'ROLE_PARTNER' && allRequiredFieldsAreFilledIn) && <>
                     {
                        // dataState.synkStatus === 'new' &&
                        <div>
                           <CButton
                              onClick={changeStatusForSendToVerify}


                              color="success"
                              disabled={dataState.synkStatus !== "new"}
                           >
                              Відправити на перевірку
                           </CButton>
                        </div>
                     }
                  </>} */}
               </>
            }
         </CForm>



      </div>
   )

}